import React, { Component }        from 'react'
import { Provider }                from 'react-redux'
import { Router }                  from 'react-router-dom'

import {createBrowserHistory} from 'history'
import configureStore       from './store/configureStore'
import route                from './route'

import 'font-awesome/css/font-awesome.css'
import './favicon.ico'
import 'typeface-roboto'
import './index.scss'
import './Desktop.scss'

export default class Web extends Component {
    render(){
        window.appHistory = createBrowserHistory()
        return (
            <Provider store={configureStore()}>
                <Router children={route} history={window.appHistory}/>
            </Provider>
        )
    }
}
